'use client'
import React, { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { RenderTabbedForm } from 'src/components/era-package/forms/RenderTabbedForm'
import ParentCard from 'src/components/era-package/shared/ParentCard'
import {
  useSelectDocForm,
  useQueryListForm,
  useAirManifestForm,
  useOceanManifestForm,
  useRailManifestForm,
  useTruckManifestForm,
  useInBondForm,
  useImporterBondForm, useResponseForm
} from './tabs'
import pathMap from 'src/paths/pathMap'
import SnackBar from '../../../../components/era-package/era/SnackBar'
import AbiQueryApiUrls from '../../../../apiUrls/AbiQueryApiUrls'
import { Interceptor } from './Interceptor'
import { Card } from '@mui/material'

const Wrapper = ({ readOnly, children }) => {
  if (readOnly) return <>{children}</>
  return <ParentCard title='ABI Query'>{children}</ParentCard>
}

// Main Component
const ABIQuery = ({ isEntrySummary, readOnly, id }) => {
  const history = useHistory()
  const [isFetching, setFetching] = useState(false)
  const [fetchedData, setFetchedData] = useState()
  const queryListProps = useQueryListForm(fetchedData, setFetchedData)
  const selectDocProps = useSelectDocForm(id, fetchedData?.selectDoc)
  const airManifestProps = useAirManifestForm(id, fetchedData?.airManifest)
  const oceanManifestProps = useOceanManifestForm(
    id,
    fetchedData?.oceanManifest
  )
  const railManifestProps = useRailManifestForm(id, fetchedData?.railManifest)
  const truckManifestProps = useTruckManifestForm(
    id,
    fetchedData?.truckManifest
  )
  const inBondProps = useInBondForm(id, fetchedData?.inBond)
  const importerBondProps = useImporterBondForm(id, fetchedData?.importerBond)
  const responseProps = useResponseForm(id, fetchedData?.queryList[0])

  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false)
  const [showSubmitErrorSnackbar, setShowSubmitErrorSnackbar] = useState(false)

  useEffect(() => {
    let isAlive = true
    let queryList = {}
    let airManifest = { outOption: '2' }
    let oceanManifest = { outOption: '2' }
    let railManifest = { outOption: '2' }
    let truckManifest = { outOption: '2' }
    let inBond = { outOption: '2' }

    fetch(AbiQueryApiUrls.GET + `?abiTransId=${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
      }
    })
      .then((res) => res.json())
      .then((json) => {
        if (isAlive && !!json.data) {
          queryList.queryList = json.data
          setFetchedData({
            ...fetchedData,
            queryList,
            airManifest,
            oceanManifest,
            railManifest,
            truckManifest,
            inBond
          })
          setFetching(true)
        }
      })
      .catch((err) => {
        console.error(err)
        setFetching(true)
      })

    return () => {
      isAlive = false
      setFetching(true)
    }
  }, [])

  // All the tabs
  const tabs = [
    {
      label: 'Query List',
      key: 'queryList',
      formProps: queryListProps
    },
    {
      label: 'Select Document Type',
      key: 'selectDoc',
      formProps: selectDocProps
    },
    {
      label: 'Air Manifest',
      key: 'airManifest',
      formProps: airManifestProps,
      hidden: (formData) => {
        return formData?.selectDoc?.docType !== 'airManifest'
      }
    },
    {
      label: 'Ocean Manifest',
      key: 'oceanManifest',
      formProps: oceanManifestProps,
      hidden: (formData) => {
        return formData?.selectDoc?.docType !== 'oceanManifest'
      }
    },
    {
      label: 'Rail Manifest',
      key: 'railManifest',
      formProps: railManifestProps,
      hidden: (formData) => {
        return formData?.selectDoc?.docType !== 'railManifest'
      }
    },
    {
      label: 'Truck Manifest',
      key: 'truckManifest',
      formProps: truckManifestProps,
      hidden: (formData) => {
        return formData?.selectDoc?.docType !== 'truckManifest'
      }
    },
    {
      label: 'In-Bond',
      key: 'inBond',
      formProps: inBondProps,
      hidden: (formData) => {
        return formData?.selectDoc?.docType !== 'inBond'
      }
    },
    {
      label: 'Importer Bond',
      key: 'importerBond',
      formProps: importerBondProps,
      hidden: (formData) => {
        return formData?.selectDoc?.docType !== 'importerBond'
      }
    },
    {
      label: 'Response',
      key: 'response',
      formProps: responseProps,
      hidden: (formData) => {
        console.log(formData?.response?.referenceNumber)
        return !formData?.response?.referenceNumber
      }
    }
  ]

  const handleSubmit = async (formData) => {
    formData.queryList = convertQueryListDatatoDTOForm(formData.queryList)
    console.log('test', formData)
    try {
      const response = await fetch(AbiQueryApiUrls.SUBMIT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
        },
        body: JSON.stringify(formData) // Convert JS object to JSON string
      })

      if (!response.ok) {
        console.error('Error fetching user data')
        setShowSubmitErrorSnackbar(true)
        return false
      }

      const result = await response.json()
      setFetchedData({
        ...fetchedData,
        response: result?.data?.response
      })
      setShowSuccessSnackbar(formData)
      console.log('submitted:', result)
      return true
    } catch (error) {
      console.error('Error fetching user data:', error)
    }
  }

  function convertQueryListDatatoDTOForm(input) {
    if (input?.queryList && Array.isArray(input?.queryList)) {
      return input.queryList
    }
    return input
  }

  // Handle snackbar close
  const handleSuccessSnackbarClose = (e, reason) => {
    setShowSuccessSnackbar(false)
  }

  // Handle snackbar close
  const handleSubmitErrorSnackbarClose = useCallback(() => {
    setShowSubmitErrorSnackbar(false)
  }, [])

  if (!isFetching) return <p>Loading user data...</p>

  return (
    <Wrapper readOnly={readOnly}>
      <RenderTabbedForm
        tabs={tabs}
        asyncDefaultValues={fetchedData}
        submitLabel='Submit'
        onSubmit={handleSubmit}
        readOnly={false}
        tabSwitcherChildren={(setActiveTab) => (
          <Interceptor setActiveTab={setActiveTab} setFetchedData={setFetchedData} fetchedData={fetchedData} />
        )}
      ></RenderTabbedForm>
      {/* Error Snackbar - Only show when showErrorSnackbar is true */}
      <SnackBar
        title='Form Submittion Error'
        type='error'
        open={showSubmitErrorSnackbar}
        onClose={handleSubmitErrorSnackbarClose}
        duration={10000}
      >
        Internal error occured, please try again later.
      </SnackBar>

      {/* Success Snackbar - Only show when showSuccessSnackbar is true */}
      <SnackBar
        title='Form submitted successfully'
        type='success'
        open={!!showSuccessSnackbar}
        onClose={handleSuccessSnackbarClose}
        duration={3000}
      >
        Redirecting to Query...
      </SnackBar>
    </Wrapper>
  )
}

export default ABIQuery
